import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { memo, useCallback } from 'react';
import { IconButton, Link, ListItemButton, ListItemIcon, ListItemSecondaryAction, ListItemText, Tooltip, } from '@mui/material';
import { Delete, Description, Photo } from '@mui/icons-material';
import { FileType, getFileType } from 'console/utils/download-files/download_file';
import { preventDefault, useCallbacks, usePartial } from 'console/shared/hooks/utils';
export const AttachmentListItem = memo(function AttachmentListItem(props) {
    const { filename, deleteItem, open_url } = props;
    // const onDownloadItem = useCallback(
    //     (e: MouseEvent<HTMLButtonElement>) => {
    //         preventDefault(e);
    //         if (!isMobileApp()) {
    //             window.location.href = download_url;
    //             return;
    //         }
    //         downloadItem();
    //     },
    //     [download_url, downloadItem]
    // );
    const onOpenItem = useCallbacks([
        preventDefault,
        usePartial(window.open, open_url, '_blank'),
    ]);
    const onDeleteItem = useCallbacks([preventDefault, deleteItem]);
    const getIcon = useCallback((filename) => getFileType(filename) === FileType.pdf ? _jsx(Description, {}) : _jsx(Photo, {}), []);
    return (_jsx(Tooltip, { title: 'Файл: ' + filename, children: _jsxs(ListItemButton, { onClick: onOpenItem, children: [_jsx(ListItemIcon, { sx: {
                        minWidth: 30,
                    }, children: getIcon(filename) }), _jsx(ListItemText, { primary: _jsx(Link, { children: filename }), sx: {
                        maxHeight: 25,
                        marginRight: 58,
                        whiteSpace: 'nowrap',
                    } }), _jsx(ListItemSecondaryAction, { children: _jsx(Tooltip, { title: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u0432\u043B\u043E\u0436\u0435\u043D\u0438\u0435", children: _jsx(IconButton, { onClick: onDeleteItem, size: "large", children: _jsx(Delete, {}) }) }) })] }) }));
});
